/**
 * @ngdoc directive
 * @name membership
 *
 * @description
 * Membership component
 */
module.directive('membership', function() {
    'use strict';
    return {
        restrict: 'E',
        replace: true,
        transclude: true,
        scope: {
            user: '=',
            labels: '=', /* {label:'', placeholder:'', info: ''} */
            disabled: "=?",
            type: '@?'
        },
        controller: function($scope, drupal) {
            $scope.form = {
                memberId: "",
                lastName: "",
                pending: false
            };

            // auto-update form if user is modified
            $scope.$watch('user.field_num_adherent', function (value) {
                $scope.form.memberId = value;
            });
            // auto-update form if user is modified
            $scope.$watch('user.field_nom', function (value) {
                $scope.form.lastName = value;
            });

            $scope.checkMemberNumber = function() {
                console.log('checkMemberNumber:', $scope.form.memberId, $scope.form.lastName);
                if (!$scope.form.pending && $scope.form.memberId && !isNaN($scope.form.memberId) && $scope.form.lastName.length > 0) {
                    $scope.form.pending = true;
                    drupal.getAccountByMemberId($scope.form.memberId, $scope.form.lastName).then(function(response) {
                        if (response) {
                            response.field_nationality = response.field_nationalite;
                            response.field_mobile = response.field_tel_portable;
                            response.field_phone = response.field_tel_fixe;
                            response.field_country = response.field_pays;
                            response.field_city = response.field_ville;
                            response.field_postal_code = response.field_cp;
                            response.field_address = response.field_adresse;
                            angular.extend($scope.user, response);
                        }
                        else {
                            $scope.form.memberId = '';
                            $scope.form.lastName = '';
                        }
                    }).finally(function () {
                        $scope.form.pending = false;
                    });
                }
            };
        },
        templateUrl: 'src/components/membership/membership.html'
    };
});
